/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Invite_X15_SentInputs */

const en_invite_x15_sent = /** @type {(inputs: Invite_X15_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to ${i?.email}. Open it in this browser to finish joining.`)
};

/**
* | output |
* | --- |
* | "We sent a sign-in link to {email}. Open it in this browser to finish joining." |
*
* @param {Invite_X15_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_sent = /** @type {((inputs: Invite_X15_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_SentInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_x15_sent(inputs)
});